import {UserRole, UserRoleStrings} from 'shared';

export const DEFAULT_USER_TOP = 12;
export const DEFAULT_DOCS_TOP = 50;

export const ROLE_SELECT_DATA: [UserRole, string][] = [
  [
    UserRole.Uploader,
    `${UserRoleStrings[UserRole.Uploader]} - access to uploading data only`,
  ],
  [
    UserRole.Member,
    `${UserRoleStrings[UserRole.Member]} - access to only specific account assets`,
  ],
  [
    UserRole.Manager,
    `${UserRoleStrings[UserRole.Manager]} - access to all of the account's assets`,
  ],
];
